export default __webpack_public_path__ + "static/media/accountBalance.d4c5e70d.svg";